import React, { useEffect, useState } from 'react'

import Tag from '@icons/Tag.jsx'
import EmbroideredBlanket from '@icons/EmbroideredBlanket.jsx'
import {
    isValidProductForFlags,
    getProductTags,
    getOfferTags,
    calculateProductPricing,
    calculateSaleStatus,
} from '@utils/productFlags'

// Reusable flag component
const FlagTag = ({ children, className = '', icon = null }) => (
    <div
        className={`px-3 py-1 border border-slate inline-flex items-center flex-0 ${className}`}
    >
        {icon && <div className="tag-icon mr-2">{icon}</div>}
        <span className="text-mobile-b4-body-4 lg:text-web-b4-body-4 text-text-primary font-akkurat">{children}</span>
    </div>
)

const FlagsNosto = ({ currentProduct, currentProductTags, tagObject }) => {
    const [isProductPage, setIsProductPage] = useState(false)

    useEffect(() => {
        setIsProductPage(window.location.pathname.includes('/products/'))
    }, [])

    // Skip rendering if product is invalid
    if (!isValidProductForFlags(currentProduct)) return null

    // Get all product information
    const tags = getProductTags(currentProductTags, currentProduct)
    const offerTags = getOfferTags(tagObject, tags)
    const vendor = currentProduct?.brand || 'Monica + Andy'

    // Get product flags
    const isEmbroidery =
        vendor === 'Monica + Andy' &&
        tags.includes('embroidery2023') &&
        !tags.includes('matchingfamilypjs')

    const hasFreeShipping = tags.includes('mrktplfreeship')

    // Calculate pricing and sale status
    const { regularPrice, listPrice } = calculateProductPricing(currentProduct)
    const { isOnSale, isSaleProduct, isDisney } = calculateSaleStatus(
        currentProduct,
        vendor,
        regularPrice,
        listPrice
    )

    let is40Off = false
    let is30Off = false

    if (vendor === 'Monica + Andy' && !isSaleProduct && !isDisney) {
        is30Off = true
    }

    let isBestOfSummer = false
    if (vendor === 'Monica + Andy' && tags.includes('bestofsummer')) {
        isBestOfSummer = true
    }

    // Check if there are any flags to display
    const hasFlags =
        offerTags.length > 0 ||
        hasFreeShipping ||
        (isEmbroidery && isProductPage) ||
        isSaleProduct ||
        isOnSale

    // Don't render if there are no flags
    if (!hasFlags) return null

    return (

        <div className="product-flags-outer">
            <div
                className={`product-flags-inner flex flex-wrap relative`}
            >
                {/* Display offer tags */}
                {offerTags.map((tag, i) => (
                    <FlagTag
                        key={`${tag}-${i}`}
                        className="bg-background-warning-3"
                    >
                        {tag}
                    </FlagTag>
                ))}

                {/* Free Shipping tag */}
                {hasFreeShipping && (
                    <FlagTag className="bg-background-success-3">
                        Free Shipping
                    </FlagTag>
                )}

                {/* Embroidery tag */}
                {isEmbroidery && isProductPage && (
                    <FlagTag
                        className={`bg-background-warning-3 text-mobile-b4-body-4 lg:text-web-b4-body-4 text-text-primary font-akkurat ${
                            !isProductPage
                                ? 'absolute bottom-4 -left-[1px]'
                                : ''
                        }`}
                        icon=""
                    >
                        Personalize It!
                    </FlagTag>
                )}

                {/* Sale tag */}
                {/* {(isSaleProduct || isOnSale) && (
                    <FlagTag
                        className="bg-background-warning-3"
                        icon={<Tag width="w-[13px]" />}
                    >
                        Extra 30% off already applied!
                    </FlagTag>
                )} */}

                {/* {is40Off && (
                    <FlagTag className="bg-background-warning-3">
                        40% Off Ends Tonight!
                    </FlagTag>
                )} */}

                {/* {isBestOfSummer && (
                    <FlagTag className="bg-background-warning-3">
                        Sale ends 8/04
                    </FlagTag>
                )} */}

                {/* {isEmbroidery && (
                    <FlagTag className="bg-background-warning-3">
                        Free Embroidery!
                    </FlagTag>
                )} */}
            </div>
        </div>
    )
}

export default FlagsNosto
